<template>
    <div>
        <div v-for="position in positions" :key="position" :class="position" class="z-[100] fixed bg-yellow-200 opacity-80" 
            style="background-image: repeating-linear-gradient(45deg, transparent, transparent 10px, black 10px, black 20px);">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            positions: [
                'h-2 w-screen top-0',
                'h-2 w-screen bottom-0',
                'w-2 h-screen left-0',
                'w-2 h-screen right-0'
            ]
        };
    }
};
</script>
